import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { AuthService, Block, BlockAbstractComponent, ParserService, ZoneService } from '@gallaghercp/core-frontend';
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import { register } from 'swiper/element';

// Install modules
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);

@Component({
  selector: 'core-coro-hero-carousel',
  templateUrl: './coro-hero-image-carousel.component.html',
  styleUrl: './coro-hero-image-carousel.component.scss',
  standalone: false,
})
export class CoroHeroImageCarouselComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
  protected override parser: ParserService;
  protected override auth: AuthService;
  protected breakpoint = inject(BreakpointObserver);
  private zoneService = inject(ZoneService);

  swiperConfig!: SwiperOptions;

  constructor() {
    const parser = inject(ParserService);
    const auth = inject(AuthService);

    super(parser, auth);

    this.parser = parser;
    this.auth = auth;
  }

  override ngOnInit() {
    super.ngOnInit();

    this.swiperConfig = {
      autoplay: false,
      effect: 'slide',
      loop: false,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-hero-image-carousel-next',
        prevEl: '.swiper-button-hero-image-carousel-prev',
      },
      slidesPerView: 1,
    };

    this.block.content.map((block: Block) => {
      if (block.data.link && block.data.link.includes('https://')) {
        block.data.targetAttr = 1;
      }
      if (block.data.link && block.data.targetAttr !== 1) {
        block.data.link = this.zoneService.injectZoneCodeUrl(block.data.link);
      }
      return block;
    });
  }

  ngAfterViewInit(): void {
    register();
  }

  getSlideImgUrl(url: string): string {
    if (url && !url.includes('https://')) {
      url = APP_CONFIG.frontend + url;
    }

    return url;
  }

  trackById(index: number, item: Block): number {
    return item?.id ?? index;
  }
}
